export default __webpack_public_path__ + "static/media/Genome.f6fc5a20.png";